import { deleteProfilePicture } from "../../redux/slices/profileSlice";
import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class ProfileService extends AxiosBase {
  getProfileDetailsData = async () => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.PROFILE.GET_PROFILE_DETAILS}`
      );
      return response;
    } catch (err) {
      throw err;
    }
  };
  updateProfileDetailsData = async (body, navigate) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.PROFILE.UPDATE_PROFILE_DETAILS}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };

  uploadProfilePicture = async (body, navigate) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.PROFILE.UPLOAD_PROFILE_PICTURE}`,
        body
      );
      return response;
    } catch (err) {
      throw err;
    }
  };
  deleteProfilePicture = async (navigate) => {
    try {
      const response = await this.requests.delete(
        `${API_ROUTES.PROFILE.UPLOAD_PROFILE_PICTURE}`
      );
      return response;
    } catch (err) {
      throw err;
    }
  };
}
